import { CommonModule } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AnalyticsService } from '@core/services/app/analytics.service';
import { ModalsService } from '@core/services/modals/modals.service';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { TranslateModule } from '@ngx-translate/core';
import { CartPrepaymentBlockComponent } from '@shared/blocks/cart-prepayment-block/cart-prepayment-block.component';
import { PrepaidAccountTopUpModalConfig } from '@shared/modals/prepayment-modal/prepaid-account-top-up-modal.component';
import { TopUpService } from '@core/services/prepayment/top-up.service';
// todo rename folder and move in block section
@Component({
  selector: 'app-prepaid-account-top-up-block',
  host: { class: 'min-h-screen' },
  standalone: true,
  imports: [CommonModule, CartPrepaymentBlockComponent, TranslateModule],
  template: `
    <div class="px-5 py-6 md:flex md:flex-col md:items-center">
      <div class="md:w-656px md:flex-auto">
        <h2 class="mb-6 font-accent text-2xl font-bold md:mb-8 md:text-3xs">
          {{ 'sidebar.navigation.credits' | translate }}
        </h2>

        <app-cart-prepayment-block />
      </div>
    </div>
  `,
  providers: [TopUpService],
})
export class PrepaidAccountTopUpBlockComponent {
  private readonly modalsService: ModalsService<[PrepaidAccountTopUpModalConfig]> =
    inject(ModalsService);
  private readonly routerHelperService = inject(RouterHelperService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly router = inject(Router);
  protected readonly topUpService = inject(TopUpService);

  constructor() {
    this.modalsService
      .event$('prepaid-account-top-up-modal')
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        if (event?.type === 'Top up added') {
          this.router.navigate([this.routerHelperService.translateRoute('/cart')]);
        }
      });
    effect(() => {
      const event = this.topUpService.events();
      if (!event) {
        return;
      }
      if (event.type === 'Top up removed') {
        this.modalsService.close('prepaid-account-top-up-modal');
      }
    });
  }
}
